import SmruLeadForm from "./SmruLeadForm";
import { usePartnerTab } from "./usePartnerTab";

export default function SmruGuidancePage() {
    usePartnerTab("Talk to our Expert — AI.Prof");

    return (
        <SmruLeadForm
            variant="guidance"
            eyebrow="Talk to our Expert"
            title="Let's Talk About Your AI Career 🚀"
            subtitle="Share a few details and our admissions team will reach out to map your path into India's first AI-powered B.Tech."
            submitLabel="Talk to our Expert Right Away"
        />
    );
}
